import React from 'react';
import {TableBasic} from './styles';

export default ({dataTableContent, minWidth}: {dataTableContent: object | any; minWidth?: string}) => (
  <TableBasic minWidth={minWidth}>
    <thead>
      <tr>
        <th style={{fontSize: '15px', fontWeight: 'bold', height: '40px', borderRight: 'none'}}>BILLING CYCLE</th>
        <th style={{fontSize: '18px', fontWeight: 'normal', height: '40px', borderRight: 'none', textAlign: 'center'}}>Total Players</th>
        <th style={{fontSize: '18px', fontWeight: 'normal', height: '40px', borderRight: 'none', textAlign: 'center'}}>Amount Owed</th>
      </tr>
    </thead>
    <tbody className="table-player-billing">
      <tr>
        <td>Monthly Sponsorships</td>
        <td>{dataTableContent?.monthlyPlayers?.quantity || 0}</td>
        <td>{dataTableContent?.monthlyPlayers?.total || 0}</td>
      </tr>
      <tr>
        <td>Prorated Players</td>
        <td>{dataTableContent?.proratedPlayers?.quantity || 0}</td>
        <td>{dataTableContent?.proratedPlayers?.total || 0}</td>
      </tr>
      <tr>
        <td style={{backgroundColor: '#F7F8FA'}}>Billing date {dataTableContent?.billingDate || '-'}</td>
        <td style={{backgroundColor: '#F7F8FA'}}>Total</td>
        <td style={{backgroundColor: '#F7F8FA', color: '#007AFF'}}>{dataTableContent?.totalOwed || 0}</td>
      </tr>
    </tbody>
  </TableBasic>
);
